var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#B8BABF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10.0938C13.9807 10.0938 12.3438 11.7307 12.3438 13.75C12.3438 15.7693 13.9807 17.4062 16 17.4062C18.0193 17.4062 19.6562 15.7693 19.6562 13.75C19.6562 11.7307 18.0193 10.0938 16 10.0938ZM10.6562 13.75C10.6562 10.7987 13.0487 8.40625 16 8.40625C18.9513 8.40625 21.3438 10.7987 21.3438 13.75C21.3438 16.7013 18.9513 19.0938 16 19.0938C13.0487 19.0938 10.6562 16.7013 10.6562 13.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 19.0933C14.7657 19.0933 13.5531 19.4182 12.4841 20.0354C11.4151 20.6527 10.5275 21.5404 9.91044 22.6094C9.67748 23.013 9.16146 23.1513 8.75788 22.9184C8.3543 22.6854 8.21599 22.1694 8.44894 21.7658C9.21412 20.4402 10.3148 19.3394 11.6403 18.5741C12.9658 17.8087 14.4694 17.4058 16 17.4058C17.5306 17.4058 19.0342 17.8087 20.3597 18.5741C21.6852 19.3394 22.7859 20.4402 23.5511 21.7658C23.784 22.1694 23.6457 22.6854 23.2421 22.9184C22.8385 23.1513 22.3225 23.013 22.0896 22.6094C21.4725 21.5404 20.5849 20.6527 19.5159 20.0354C18.447 19.4182 17.2344 19.0933 16 19.0933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/user_default.6af9ffb6.svg";
export { ForwardRef as ReactComponent };